/* tslint:disable */
/* eslint-disable */
/**
 * InnerAnalytics MNT Server
 * InnerAnalytics MNT server API specification.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * ClinicInvitationApi - axios parameter creator
 * @export
 */
export const ClinicInvitationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update the patient\'s clinic invitation
         * @param {number} invitation_id 
         * @param {AppApiPatientPutPatientClinicInvitationStatusEnum} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientPutPatientClinicInvitation: async (invitation_id: number, status: AppApiPatientPutPatientClinicInvitationStatusEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitation_id' is not null or undefined
            assertParamExists('appApiPatientPutPatientClinicInvitation', 'invitation_id', invitation_id)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('appApiPatientPutPatientClinicInvitation', 'status', status)
            const localVarPath = `/clinic-invitation/{invitation_id}`
                .replace(`{${"invitation_id"}}`, encodeURIComponent(String(invitation_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClinicInvitationApi - functional programming interface
 * @export
 */
export const ClinicInvitationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClinicInvitationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update the patient\'s clinic invitation
         * @param {number} invitation_id 
         * @param {AppApiPatientPutPatientClinicInvitationStatusEnum} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiPatientPutPatientClinicInvitation(invitation_id: number, status: AppApiPatientPutPatientClinicInvitationStatusEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiPatientPutPatientClinicInvitation(invitation_id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClinicInvitationApi - factory interface
 * @export
 */
export const ClinicInvitationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClinicInvitationApiFp(configuration)
    return {
        /**
         * 
         * @summary Update the patient\'s clinic invitation
         * @param {ClinicInvitationApiAppApiPatientPutPatientClinicInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientPutPatientClinicInvitation(requestParameters: ClinicInvitationApiAppApiPatientPutPatientClinicInvitationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.appApiPatientPutPatientClinicInvitation(requestParameters.invitation_id, requestParameters.status, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for appApiPatientPutPatientClinicInvitation operation in ClinicInvitationApi.
 * @export
 * @interface ClinicInvitationApiAppApiPatientPutPatientClinicInvitationRequest
 */
export interface ClinicInvitationApiAppApiPatientPutPatientClinicInvitationRequest {
    /**
     * 
     * @type {number}
     * @memberof ClinicInvitationApiAppApiPatientPutPatientClinicInvitation
     */
    readonly invitation_id: number

    /**
     * 
     * @type {'accepted' | 'rejected' | 'pending' | 'expired' | 'revoked'}
     * @memberof ClinicInvitationApiAppApiPatientPutPatientClinicInvitation
     */
    readonly status: AppApiPatientPutPatientClinicInvitationStatusEnum
}

/**
 * ClinicInvitationApi - object-oriented interface
 * @export
 * @class ClinicInvitationApi
 * @extends {BaseAPI}
 */
export class ClinicInvitationApi extends BaseAPI {
    /**
     * 
     * @summary Update the patient\'s clinic invitation
     * @param {ClinicInvitationApiAppApiPatientPutPatientClinicInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicInvitationApi
     */
    public appApiPatientPutPatientClinicInvitation(requestParameters: ClinicInvitationApiAppApiPatientPutPatientClinicInvitationRequest, options?: AxiosRequestConfig) {
        return ClinicInvitationApiFp(this.configuration).appApiPatientPutPatientClinicInvitation(requestParameters.invitation_id, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AppApiPatientPutPatientClinicInvitationStatusEnum = {
    Accepted: 'accepted',
    Rejected: 'rejected',
    Pending: 'pending',
    Expired: 'expired',
    Revoked: 'revoked'
} as const;
export type AppApiPatientPutPatientClinicInvitationStatusEnum = typeof AppApiPatientPutPatientClinicInvitationStatusEnum[keyof typeof AppApiPatientPutPatientClinicInvitationStatusEnum];
